module.exports = __webpack_public_path__ + "assets/img/e96cc8d178a5374e6f41c3ce7d8a1245.png";